// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Admin {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    /* margin-top: 5rem; */
    margin-bottom: 10rem;

}

.BAdmin {
    display: flex;
    /* new */
    align-items: center;
    /* new */
    justify-content: center;
    text-align: center;
    background-color: var(--violet);
    color: var(--blanc);
    margin: 1rem;
    border-width: 0rem;
    border-radius: 0.4rem;
    text-decoration: none;
    padding: 10px 16px
}

.BAdmin:hover {
    background-color: var(--bleu);
    cursor: pointer;
}

@media screen and (max-width: 600px) {
    .Admin {
        margin-bottom: 0rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Admin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;;AAExB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".Admin {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n    /* margin-top: 5rem; */\n    margin-bottom: 10rem;\n\n}\n\n.BAdmin {\n    display: flex;\n    /* new */\n    align-items: center;\n    /* new */\n    justify-content: center;\n    text-align: center;\n    background-color: var(--violet);\n    color: var(--blanc);\n    margin: 1rem;\n    border-width: 0rem;\n    border-radius: 0.4rem;\n    text-decoration: none;\n    padding: 10px 16px\n}\n\n.BAdmin:hover {\n    background-color: var(--bleu);\n    cursor: pointer;\n}\n\n@media screen and (max-width: 600px) {\n    .Admin {\n        margin-bottom: 0rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
